export const isCardCreating = (status?: string | null) =>
	(status || "").toLowerCase() === "created"

export const isCardPermanentlyBlocked = (status?: string | null) =>
	["blocked", "closed"].includes((status || "").toLowerCase())

export const preservePermanentCardStatus = <T extends { uid: string; status: string }>(
	known: Pick<T, "uid" | "status"> | undefined, incoming: T
): T => known?.uid === incoming.uid && isCardPermanentlyBlocked(known.status) && !isCardPermanentlyBlocked(incoming.status)
	? { ...incoming, status: known.status } : incoming

export const CARD_BLOCKING_STATUS = "blocking"

/** Backend 409 for top-up, withdraw, freeze and unfreeze while cards/block is running. */
export const CARD_BLOCKING_ERROR_CODE = 2501

export const isCardBlockingError = (error?: { code?: number } | null) =>
	error?.code === CARD_BLOCKING_ERROR_CODE

export const isCardBlocking = (card?: { status?: string | null; blocking?: boolean } | null) =>
	Boolean(card?.blocking) && !isCardPermanentlyBlocked(card?.status)

/** Status shown in pills: a running block reads as "blocking" while the API status is still active/frozen. */
export const getCardDisplayStatus = (card: { status?: string | null; blocking?: boolean }) =>
	isCardBlocking(card) ? CARD_BLOCKING_STATUS : card.status

export const getCardStatusDisplayLabel = (status?: string | null) => {
	if (!status) return "N/A"
	if (isCardCreating(status)) return "creating"
	if (status === CARD_BLOCKING_STATUS) return "Blocking…"
	return status.replaceAll("_", " ")
}
